import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';

import ROLES from 'config/roles';
import ROUTES from 'config/routes';
import Navbar from './Navbar';
import Search from './Search';
import SocialLinks from 'components/SocialLinks';
import Button from 'components/Button';
import MobileMenu from './MobileMenu';
import Profile from './Profile';
import MobileProfileMenu from './MobileProfileMenu';
import Icon, { ICON_NAMES } from 'components/Icon';
import JobsModule from 'modules/jobs';
import ResumeModule from 'modules/resumes';


const Header = props => {
  const {
    isMobile, isScrolled, isAuth, role, id, first_name, last_name, company_name, contact_name, socials, favoriteList,
    getFavoriteJobsIds, getFavoriteResumesIds,
    hash
  } = props;

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);

  const isCaregiver = isAuth && !(role === ROLES.FAMILY_OR_FRIEND
    || role === ROLES.AGENCY
    || role === ROLES.SELF
    || role === ROLES.STUDENT);

  useEffect(() => {
    isAuth && (isCaregiver
      ? getFavoriteJobsIds()
      : getFavoriteResumesIds());
  }, []);

  const handleMenuOpen = () => {
    setMenuOpen(true);
  }
  const handleMenuClose = () => {
    setMenuOpen(false);
  }

  const handleProfileMenuOpen = () => {
    setProfileMenuOpen(true);
  }
  const handleProfileMenuClose = () => {
    setProfileMenuOpen(false);
  }

  const menuItems = [
    {
      title: 'Membership',
      url: ROUTES.membership,
    },
    {
      title: 'Job Board / Career center',
      url: ROUTES.careerCenter,
    },
    {
      title: 'Marketplace',
      url: ROUTES.marketplace,
    },
    {
      title: 'News & Articles',
      url: ROUTES.articles,
    },
    {
      title: 'Forum',
      url: ROUTES.forum,
    },
    // {
    //   title: 'About us',
    //   url: ROUTES.aboutUs,
    // },
    {
      title: 'About us',
      withArrow: true,
      url: ROUTES.aboutUs,
      submenu: [
        {
          title: 'Note from Founder',
          url: ROUTES.aboutUs,
        },
        {
          title: 'Our Team',
          url: ROUTES.aboutUs,
        },
        {
          title: 'Advisory Board',
          url: ROUTES.aboutUs,
        },
      ],
    },
    {
      title: 'Other',
      withArrow: true,
      submenu: [
        {
          title: 'Events',
          url: ROUTES.events,
        },
        {
          title: 'Education, Training, Certification',
          url: ROUTES.educationTrainingCertification,
        },
        {
          title: 'Trusted Advisor',
          url: ROUTES.trustedAdvisorProgram,
        },
      ],
    },
  ];

  return (
    <Fragment>
      <div className="header-wrapper">
        <header
          className={classNames("header", {
            "header--sticky": isScrolled,
          })}>
          <div className="container">
            <div className="row align-items-center">
              {
                isMobile &&
                <div className="col-4">
                  <Button
                    bgColor={null}
                    width='auto'
                    className="btn menu-btn"
                    onClick={handleMenuOpen}>
                    <span className="menu-btn__line" />
                  </Button>
                </div>
              }
              <div className="col-4 col-lg-2 text-center">
                <Link to={ROUTES.home} className="header__logo">
                  <img src="/img/logo.svg" alt="logo" />
                </Link>
              </div>
              <div className="col-4 col-lg-10">
                <div className="header__top">
                  <div className="row justify-content-between">
                    <div className="col-md-6 col-lg-auto d-none d-lg-block">
                      {isAuth && <Search />}
                    </div>
                    <div className="col-auto d-none d-lg-block">
                      <SocialLinks socials={socials} />
                    </div>
                    <div className="col-12 col-lg-auto d-flex justify-content-end">
                      {
                        !isAuth
                          ? (<Fragment>
                            <Button
                              bgColor={null}
                              width='auto'
                              to={ROUTES.signIn}>Log in</Button>
                            <Button to={ROUTES.signUp} className="d-none d-md-flex">REGISTER HERE</Button>
                          </Fragment>)
                          : isMobile
                            ? <button
                              className="profile-btn"
                              onClick={handleProfileMenuOpen}>
                              <Icon
                                name={ICON_NAMES.user}
                                className="icon--profile profile-btn__icon" />
                            </button>
                            : <Profile
                              role={role}
                              id={id}
                              first_name={first_name}
                              last_name={last_name}
                              company_name={company_name}
                              contact_name={contact_name}
                              favoriteList={favoriteList} />
                      }
                    </div>
                  </div>
                </div>
                {
                  !isMobile &&
                  <Navbar menuItems={menuItems} isAuth={isAuth} hash={hash} />
                }
              </div>
            </div>
          </div>
        </header>
        {
          isMobile &&
          <MobileMenu
            isMenuOpen={isMenuOpen}
            menuItems={menuItems}
            isAuth={isAuth}
            onClose={handleMenuClose}
            socials={socials}
            hash={hash} />
        }
        {
          isMobile && isAuth &&
          <MobileProfileMenu
            isMenuOpen={isProfileMenuOpen}
            onClose={handleProfileMenuClose}
            role={role} />
        }
      </div>
    </Fragment>
  )
}


export default connect(
  state => {
    const { role } = state.auth;
    if (role === ROLES.FAMILY_OR_FRIEND
      || role === ROLES.AGENCY
      || role === ROLES.SELF
      || role === ROLES.STUDENT) {
      return {
        role,
        isAuth: state.auth.isAuth,
        id: state.auth.id,
        first_name: state.profile.userData.first_name,
        last_name: state.profile.userData.last_name,
        company_name: state.profile.userData.company_name,
        contact_name: state.profile.userData.contact_name,
        isMobile: state.common.windowWidth < 992,
        isScrolled: state.common.windowScrollTop > 30,
        favoriteList: state.resumes.favorite.ids,
      }
    } else {
      return {
        role,
        isAuth: state.auth.isAuth,
        id: state.auth.id,
        first_name: state.profile.userData.first_name,
        last_name: state.profile.userData.last_name,
        company_name: state.profile.userData.company_name,
        contact_name: state.profile.userData.contact_name,
        isMobile: state.common.windowWidth < 992,
        isScrolled: state.common.windowScrollTop > 30,
        favoriteList: state.jobs.favorite.ids,
      }
    }
  },
  {
    getFavoriteJobsIds: JobsModule.getFavoriteJobsIds,
    getFavoriteResumesIds: ResumeModule.getFavoriteResumesIds,
  }
)(Header);
